import { defineStore } from "pinia";

import axios from "../../axios-auth";
import hash from "object-hash";
import {
  makeQueryFromObject,
  computeCustomFormatLabel
} from "../../helpers/helpers";
import { i18n } from "../../i18n.js";
import { useUrlsStore } from "@/stores/modules/urls";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePreview3DStore } from "@/stores/modules/preview3D";
import { usePreview2DStore } from "@/stores/modules/preview2D";

export const usePackingOptionsStore = defineStore("packingoptions", {
  state: () => ({
    options: {
      /* stucture should be
      format:{
        Length:{
            code:'packing_format_Length'
            label:'Length(mm)
            value:100,
            visible:true,
            index // to be used on sort display
        }
      } */
    },
    defaults: {
      // same structure as options
    },
    previewLoading: false,
    refreshGetDataPP: [],
    packingCustomFormats: {
      /*custom_10_20: {
      label: "Custom mm",
      value: "custom_10_20",
      options: {
        Length: "100",
        Width: "100",
        Depth: "100"
      }
    }*/
    },
    limits: {},
    mainWindow: null,
    prevPackingGetData: null
  }),

  getters: {
    getPOValueNeededForGetData(state) {
      const changeOptionsStore = useChangeOptionsStore();
      const webproductStore = useWebproductStore();
      if (changeOptionsStore.getIsChangeOptionsEmpty) {
        return {};
      }
      const allPageOptions = webproductStore.getAllProductPageOptions(true);
      const data = {};
      for (let refreshPo in this.getRefreshGetDataPP) {
        const refreshItem = this.getRefreshGetDataPP[refreshPo];
        data[refreshItem] = allPageOptions[refreshItem].selected[0];
      }
      return data;
    },
    getPrevPackingGetData(state) {
      return state.prevPackingGetData;
    },
    getMainWindow(state) {
      return state.mainWindow;
    },
    getDownloadFileName(state) {
      const webproductStore = useWebproductStore();
      const sku = encodeURIComponent(webproductStore.getWebProductSku);
      const sku_info = sku ? "_" + sku : "";
      const options = this.getPackingOptions;
      let prop = "";
      if (options.length > 0) {
        prop =
          "_" +
          options
            .map(el => {
              return el.value;
            })
            .join("_");
      }
      return "product" + sku_info + "_" + webproductStore.getInputUnit + prop;
    },
    getLimits(state) {
      return state.limits;
    },
    getPreviewLoading(state) {
      return state.previewLoading;
    },
    getPackingCustomFormats(state) {
      return state.packingCustomFormats;
    },
    getRefreshGetDataPP(state) {
      return state.refreshGetDataPP;
    },
    getPackingOptions(state) {
      var activeOptions = state.options;
      var options = [];
      for (var opt in activeOptions) {
        for (var item in activeOptions[opt]) {
          if (activeOptions[opt][item].visible) {
            options.push({
              code: "packing_" + opt + "_" + item,
              label: activeOptions[opt][item].label,
              value: activeOptions[opt][item].value,
              index: activeOptions[opt][item].index
            });
          }
        }
      }

      options.sort(function (a, b) {
        return a.index == b.index ? 0 : a.index > b.index ? 1 : -1;
      });
      return options;
    },
    getPackingOptionsData(state) {
      var activeOptions = state.options;
      var options = {};
      for (var opt in activeOptions) {
        for (var item in activeOptions[opt]) {
          if (
            activeOptions[opt][item].value != "" &&
            parseFloat(activeOptions[opt][item].value) != 0
          ) {
            if (activeOptions[opt][item].code == "Color") {
              options["papercolor"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "Texture") {
              options["outsideTexture"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "Inside_texture") {
              options["insideTexture"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "PackingDoubleSided") {
              options["packingDoubleSided"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "FlippedPage") {
              options["flippedPage"] = activeOptions[opt][item].value;
            } else if (
              (activeOptions[opt][item].code == "WH" ||
                activeOptions[opt][item].code == "MDS") &&
              typeof activeOptions[opt][item].value === "string"
            ) {
              options[activeOptions[opt][item].code] =
                "'" + activeOptions[opt][item].value.replaceAll("'", "") + "'";
            } else {
              options[activeOptions[opt][item].code] =
                activeOptions[opt][item].value;
            }
          }
        }
      }
      return options;
    },
    getPackingOptionsDataForGetData(state) {
      var activeOptions = state.options;
      const webproductStore = useWebproductStore();
      var packingVars = webproductStore.getPackagingVariables;
      var options = {};
      for (var opt in activeOptions) {
        for (var item in activeOptions[opt]) {
          if (
            activeOptions[opt][item].value != "" &&
            parseFloat(activeOptions[opt][item].value) != 0
          ) {
            if (opt == "format") {
              if (!(activeOptions[opt][item].code in packingVars)) {
                continue;
              }
            }
            if (activeOptions[opt][item].code == "Color") {
              options["papercolor"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "Texture") {
              options["outsideTexture"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "Inside_texture") {
              options["insideTexture"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "PackingDoubleSided") {
              options["packingDoubleSided"] = activeOptions[opt][item].value;
            } else if (activeOptions[opt][item].code == "FlippedPage") {
              options["flippedPage"] = activeOptions[opt][item].value;
            } else if (
              (activeOptions[opt][item].code == "WH" ||
                activeOptions[opt][item].code == "MDS") &&
              typeof activeOptions[opt][item].value === "string"
            ) {
              options[activeOptions[opt][item].code] =
                "'" + activeOptions[opt][item].value.replaceAll("'", "") + "'";
            } else {
              options[activeOptions[opt][item].code] =
                activeOptions[opt][item].value;
            }
          }
        }
      }
      return options;
    },
    getPackingDataForm(state) {
      const webproductStore = useWebproductStore();
      const preview3DStore = usePreview3DStore();
      let packingDataForm = {
        model: webproductStore.getPackagingModel,
        Thickness: 0.3,
        Input_Unit: webproductStore.getInputUnit,
        return_type: "json",
        hide_buttons: true,
        hasTdImage: preview3DStore.getImageTd.length != 0,
        ...this.getPackingOptionsDataForGetData
      };
      if (webproductStore.getStoreCode) {
        packingDataForm.store_code = webproductStore.getStoreCode;
      }
      return packingDataForm;
    },
    getPackingDownloadPdfData(state) {
      return makeQueryFromObject({
        ...this.getPackingDataForm,
        return_type: "download",
        filename: this.getDownloadFileName + ".pdf",
        Show_Overall_Dimensions: 1
      });
    },
    getPackingDownloadCf2Data(state) {
      return makeQueryFromObject({
        ...this.getPackingDataForm,
        return_type: "download",
        filename: this.getDownloadFileName + ".cf2"
      });
    },
    getPackingHiddenInputs(state) {
      const webproductStore = useWebproductStore();
      var packingData = {
        "print_options[packing][packaging_inputs][Input_Unit][]":
          webproductStore.getInputUnit
      };
      var activeOptions = this.getPackingOptionsData;
      for (var opt in activeOptions) {
        packingData["print_options[packing][packaging_inputs][" + opt + "][]"] =
          activeOptions[opt];
      }
      return packingData;
    },
    getExistingPackingFormat(state) {
      const webproductStore = useWebproductStore();
      if (state.options["format"]) {
        // get input format options with their values
        var packingVars = webproductStore.getPackagingVariables;
        var options = Object.keys(state.options["format"])
          .filter(item => {
            return item in packingVars;
          })
          .map(el => {
            return {
              code: [state.options["format"][el].code],
              value: state.options["format"][el].value
            };
          })
          .reduce((obj, item) => {
            obj[item.code] = item.value;
            return obj;
          }, {});

        var activeProductPageOptions =
          webproductStore.getAllProductPageOptions(true);

        var opt = "format";
        for (var ppValue of activeProductPageOptions[opt].values) {
          // for format we need all fields, not just the selected/active ones
          var matchedAttributes = 0;
          for (var attribute in ppValue.attributes) {
            var attributeName = getAttributeName(attribute, opt);
            if (!attributeName) {
              continue;
            }

            if (
              Object.keys(options).includes(attributeName) &&
              options[attributeName] == ppValue.attributes[attribute]
            ) {
              matchedAttributes++;
            }
          }

          if (matchedAttributes == Object.keys(options).length) {
            // we found the format
            return ppValue.value;
          }
        }
        // also search in custom formats
        for (var pack in this.getPackingCustomFormats) {
          matchedAttributes = 0;

          for (var packOptions in this.getPackingCustomFormats[pack].options) {
            if (
              Object.keys(options).includes(packOptions) &&
              options[packOptions] ==
                this.getPackingCustomFormats[pack].options[packOptions]
            ) {
              matchedAttributes++;
            }
          }
          if (matchedAttributes == Object.keys(options).length) {
            // we found the format
            return this.getPackingCustomFormats[pack].value;
          }
        }
      }
      return null;
    }
  },

  actions: {
    loadInitialPackingOptions(payload) {
      const webproductStore = useWebproductStore();
      var activeProductPageOptions =
        webproductStore.getAllProductPageOptions(true);
      var activeAttributes = {};
      var refreshGetDataPP = [];
      for (var opt in activeProductPageOptions) {
        for (var ppValue of activeProductPageOptions[opt].values) {
          // for format we need all fields, not just the selected/active ones

          for (var attribute in ppValue.attributes) {
            var attributeName = getAttributeName(attribute, opt);
            if (!attributeName) {
              continue;
            }

            if (!refreshGetDataPP.includes(opt)) {
              refreshGetDataPP.push(opt);
            }

            if (
              opt != "format" &&
              !activeProductPageOptions[opt].selected.includes(ppValue.value)
            ) {
              continue;
            }

            var packingFound = getPackingVariableLable(attributeName);

            if (!activeAttributes[opt]) {
              activeAttributes[opt] = {};
            }
            var value = "";
            if (opt == "format") {
              if (
                activeProductPageOptions[opt].selected.includes(ppValue.value)
              ) {
                value = ppValue.attributes[attribute];

                if (activeAttributes[opt][attributeName]) {
                  activeAttributes[opt][attributeName].value = value;
                  continue;
                }
              }
            } else {
              value = ppValue.attributes[attribute];
            }
            if (!activeAttributes[opt][attributeName]) {
              activeAttributes[opt][attributeName] = {
                code: attributeName,
                label: packingFound ? packingFound.label : attributeName,
                value,
                visible: packingFound ? true : false,
                index: packingFound ? packingFound.index : 9999
              };
            }
          }
        }
      }

      if (activeAttributes["format"] && this.defaults["format"]) {
        for (var optFormat in activeAttributes["format"]) {
          if (
            (activeAttributes["format"][optFormat].value == "" ||
              activeAttributes["format"][optFormat].value == null) &&
            Object.keys(this.defaults["format"]).includes(optFormat)
          ) {
            // put de default value
            activeAttributes["format"][optFormat].value =
              this.defaults["format"][optFormat].value ?? "";
          }
        }
      }

      this.options = activeAttributes;
      this.refreshGetDataPP = refreshGetDataPP;
    },

    loadPackingOption(payload) {
      const webproductStore = new useWebproductStore();
      var activeProductPageOptions =
        webproductStore.getAllProductPageOptions(true);
      var activeAttributes = {};

      var opt = payload.option;
      for (var ppValue of activeProductPageOptions[payload.option].values) {
        if (activeProductPageOptions[opt].selected.includes(ppValue.value)) {
          for (var attribute in ppValue.attributes) {
            var attributeName = getAttributeName(attribute, payload.option);
            if (!attributeName) {
              continue;
            }

            var packingFound = getPackingVariableLable(attributeName);

            if (!activeAttributes[attributeName]) {
              activeAttributes[attributeName] = {
                code: attributeName,
                label: packingFound ? packingFound.label : attributeName,
                value: ppValue.attributes[attribute],
                visible: packingFound ? true : false,
                index: packingFound ? packingFound.index : 9999
              };
            }
          }

          break;
        }
      }

      // search also in custom formats
      if (payload.option == "format") {
        if (this.packingCustomFormats[payload.value]) {
          for (attribute in this.packingCustomFormats[payload.value].options) {
            attributeName = attribute;
            packingFound = getPackingVariableLable(attributeName);
            if (!activeAttributes[attributeName]) {
              activeAttributes[attributeName] = {
                code: attributeName,
                label: packingFound ? packingFound.label : attributeName,
                value:
                  this.packingCustomFormats[payload.value].options[attribute],
                visible: true,
                index: packingFound ? packingFound.index : 9999
              };
            }
          }
        }
      }

      var options = { ...this.options };
      if (this.defaults[opt]) {
        options[opt] = this.defaults[opt];
      } else {
        options[opt] = {};
      }

      options[opt] = { ...options[opt], ...activeAttributes };
      this.options = options;
    },
    setPackingOptionValue(payload) {
      var parts = payload.code.split("_");
      var optionCode = parts.slice(2).join("_");
      var options = { ...this.options };
      options[parts[1]][optionCode] = {
        ...options[parts[1]][optionCode],
        value: payload.value
      };
      this.options = options;
    },
    setLimits(payload) {
      this.limits = payload;
    },
    setMainWindow(payload) {
      this.mainWindow = payload;
    },
    setPreviewLoading(payload) {
      this.previewLoading = payload;
    },
    setDefaults(payload) {
      const webproductStore = useWebproductStore();
      var defaults = {};
      for (var option in payload) {
        var labelName = null;
        for (var packVar in webproductStore.getPackagingVariables) {
          if (webproductStore.getPackagingVariables[packVar].code == option) {
            labelName = webproductStore.getPackagingVariables[packVar].label;
            break;
          }
        }
        defaults[option] = {
          code: option,
          value: payload[option],
          label: labelName,
          visible: labelName ? true : false
        };
      }
      if (this.options["format"]) {
        for (var opt in this.options["format"]) {
          if (
            this.options["format"][opt].value == "" &&
            Object.keys(defaults).includes(opt)
          ) {
            // put de default value
            this.options["format"][opt].value = defaults[opt].value;
          }
        }
      } else {
        this.options["format"] = {};
      }
      this.defaults["format"] = defaults;
    },
    insertNewPackingCustomFormat({ formatPayload, code }) {
      const webproductStore = useWebproductStore();
      var packingVars = webproductStore.getPackagingVariables;
      var formatOptions = Object.keys(this.options["format"])
        .filter(item => {
          return item in packingVars;
        })
        .map(el => {
          return { label: el, value: this.options["format"][el].value };
        })
        .reduce((obj, item) => {
          obj[item.label] = item.value;
          return obj;
        }, {});
      var newCustomType = {
        [code]: {
          label: computeCustomFormatLabel(
            webproductStore.getMeasurementSystem,
            formatPayload.width,
            formatPayload.height,
            formatOptions
          ),
          value: code,
          options: { ...formatOptions }
        }
      };
      this.packingCustomFormats = {
        ...this.packingCustomFormats,
        ...newCustomType
      };
    },
    setPrevPackingGetData(payload) {
      this.prevPackingGetData = payload;
    },
    setPackingOption(payload) {
      if (payload.code) {
        this.setPackingOptionValue(payload);
      } else {
        this.loadPackingOption(payload);
      }
    },
    packingGetData(payload) {
      const urlsStore = useUrlsStore();
      const preview3DStore = usePreview3DStore();
      const preview2DStore = usePreview2DStore();
      const webproductStore = useWebproductStore();
      const changeOptionsStore = useChangeOptionsStore();
      var sendData = this.getPackingDataForm;
      //cache getData call
      if (hash(sendData) == this.getPrevPackingGetData) {
        // same hash ... no need to call again getData
        if (payload.setLoading) {
          webproductStore.setIsLoading(false);
        }
        return;
      }

      this.setPreviewLoading(true);

      var existingPackingFormat = this.getExistingPackingFormat;
      if (existingPackingFormat) {
        changeOptionsStore.setPageOptionFormat({
          option: "format",
          value: existingPackingFormat
        });
      }

      if (preview3DStore.getPreview3D) {
        jQuery("#" + preview3DStore.get3DPreviewId + " iframe")
          .get(0)
          .contentWindow.postMessage(
            JSON.stringify({
              changeDimension: sendData
            }),
            "*"
          );
      }

      axios.instance
        .get(urlsStore.getUrl(axios.packingGetData), {
          params: sendData
        })
        .then(response => {
          this.setPrevPackingGetData(hash(sendData));
          if (response.data.image) {
            if (!preview3DStore.getPreview3D) {
              preview3DStore.setPreview3D(response.data["3DUrl"]);
            }
            preview2DStore.setPreview2D(response.data.image);

            this.setDefaults(response.data.defaults);

            this.setLimits(response.data.limits);

            // insert the new format if it does not exist
            if (!existingPackingFormat) {
              var new_code =
                "custom_" +
                response.data.format.width +
                "_" +
                response.data.format.height;
              this.insertNewPackingCustomFormat({
                formatPayload: response.data.format,
                code: new_code
              });
              changeOptionsStore.setPageOptionFormat({
                option: "format",
                value: new_code
              });
            }

            if (payload && payload.callChangeOptions) {
              changeOptionsStore.changeOptions({});
            }

            if (payload.setLoading) {
              webproductStore.setIsLoading(false);
            }

            this.setPreviewLoading(false);
          } else {
            if (payload.setLoading) {
              webproductStore.setIsLoading(false);
            }
            var wnd = payload.wnd || this.getMainWindow;
            if (response.data.message && payload && wnd) {
              webproductStore.getSweetAlert({
                text: response.data.message,
                icon: "warning"
              });
              this.setPreviewLoading(false);
              preview3DStore.setPreview3DLoading(false);
              return;
            }
          }
        })
        .catch(error => {
          console.log("Error " + error);
          console.log(error);
          if (payload.setLoading) {
            webproductStore.setIsLoading(false);
          }
          this.setPreviewLoading(false);
        });
    },
    packingDownloadPdf(payload) {
      const urlsStore = useUrlsStore();
      window.location =
        urlsStore.getUrl(axios.packingGetPdf) +
        "?" +
        this.getPackingDownloadPdfData;
    },
    packingDownloadCf2(payload) {
      const urlsStore = useUrlsStore();
      window.location =
        urlsStore.getUrl(axios.packingGetCf2) +
        "?" +
        this.getPackingDownloadCf2Data;
    },
    updatePackagingAttributes(payload) {
      const webproductStore = useWebproductStore();

      const options = webproductStore.getAllProductPageOptions(true);
      const packingOptions = state.options;

      for (let pageOption in options) {
        const currentOption = options[pageOption];
        const poValues = currentOption.values ?? [];
        const selectedValues = poValues.filter(poValue => {
          return currentOption.selected.includes(poValue.value);
        });

        for (let currentValue in selectedValues) {
          const attributes = selectedValues[currentValue].attributes ?? [];
          for (let currentAttr in attributes) {
            let attributeName = getAttributeName(currentAttr, pageOption);
            if (
              attributeName &&
              typeof packingOptions[pageOption] !== "undefined" &&
              typeof packingOptions[pageOption][attributeName] !== "undefined"
            ) {
              const packingAttributeValue =
                packingOptions[pageOption][attributeName].value ?? null;
              if (packingAttributeValue !== attributes[currentAttr]) {
                this.setPackingOption({
                  value: attributes[currentAttr],
                  layout: false,
                  option: pageOption,
                  optionType: currentOption.type ?? "single"
                });
              }
            }
          }
        }
      }
    }
  }
});

const getAttributeName = (attribute, option) => {
  var attributeName = null;
  if (attribute.startsWith("packing_" + option)) {
    attributeName = attribute.replace("packing_" + option + "_", "");
  } else if (attribute.startsWith("packaging")) {
    attributeName = attribute.replace("packaging_", "");
  } else if (attribute == "packing_value") {
    attributeName = "Thickness";
  } else if (attribute == "packing_double_sided") {
    attributeName = "packingDoubleSided";
  } else if (attribute == "packing_flipped_page") {
    attributeName = "flippedPage";
  } else {
    return null;
  }

  attributeName =
    attributeName.charAt(0).toUpperCase() + attributeName.slice(1);
  if (attributeName == "Wh") {
    attributeName = "WH";
  }
  if (attributeName == "Mds") {
    attributeName = "MDS";
  }
  return attributeName;
};

const getPackingVariableLable = attributeName => {
  const webproductStore = new useWebproductStore();
  var counter = 0;
  for (var packVar in webproductStore.getPackagingVariables) {
    if (webproductStore.getPackagingVariables[packVar].code == attributeName) {
      return {
        label: webproductStore.getPackagingVariables[packVar].label,
        index: counter
      };
    }
    counter++;
  }
  return null;
};
